// extracted by mini-css-extract-plugin
export default {"name":"SettingsBusinessInfoCompanyName_name__KsD5y"};